module.exports = __webpack_public_path__ + "media/images/phone-icon-3481fd5394a6645550a8713cef53aa0f.svg";